document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---------- Cart drawer ---------- */
  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function openCartDrawer() {
    var drawer = getDrawer();
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    }
  }

  function closeCartDrawer() {
    var drawer = getDrawer();
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  window.openCartDrawer = openCartDrawer;

  window.refreshCartDrawer = function () {
    var wasOpen = getDrawer() && getDrawer().classList.contains('is-open');
    fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('#cart-drawer');
        var oldDrawer = getDrawer();
        if (newDrawer && oldDrawer) {
          if (wasOpen) {
            newDrawer.classList.add('is-open');
            newDrawer.setAttribute('aria-hidden', 'false');
          }
          oldDrawer.replaceWith(newDrawer);
        }
      })
      .catch(function () {});
  };

  /* Event delegation so listeners survive drawer re-renders */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-toggle]')) {
      event.preventDefault();
      openCartDrawer();
      window.refreshCartDrawer();
    }
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      closeCartDrawer();
    }
  });

  window.updateCartCount = function (count) {
    var badge = document.querySelector('[data-cart-count]');
    if (badge) badge.textContent = count;
  };

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.getAttribute('data-target-index'), 10);
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
        });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Announcement / generic accordions ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = trigger.nextElementSibling;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !expanded);
      if (panel) panel.hidden = expanded;
    });
  });

  /* ---------- Before / After slider ---------- */
  document.querySelectorAll('[data-before-after]').forEach(function (widget) {
    var range = widget.querySelector('[data-before-after-range]');
    var afterEl = widget.querySelector('[data-before-after-clip]');
    if (range && afterEl) {
      range.addEventListener('input', function () {
        afterEl.style.clipPath = 'inset(0 ' + (100 - range.value) + '% 0 0)';
      });
    }
  });

  /* ---------- Fade-in on scroll ---------- */
  var animateTargets = document.querySelectorAll('[data-animate]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    animateTargets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  } else {
    var animateObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    animateTargets.forEach(function (el) {
      animateObserver.observe(el);
    });
  }
});
